import { render } from "./CardHome.vue?vue&type=template&id=5bba4be3&scoped=true"
import script from "./CardHome.vue?vue&type=script&lang=js"
export * from "./CardHome.vue?vue&type=script&lang=js"

import "./CardHome.vue?vue&type=style&index=0&id=5bba4be3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bba4be3"]])

export default __exports__